<template>
  <header class="header-df flex jcb aic ">
    <div class="left flex aic">
      <img src="@/assets/images/logo.png" alt="" class="logo vam csp" @click="changeTab({value:'home'})" />
      <div class="tabs-box">
        <div class="tabs-content ">
          <div class="flex aic menu-box">
            <template v-for="(tab, ind) in tabsList">
              <p :key="ind" class="tabs-item csp fs16" :class="{'tabs-active': !noTabsActive && currentTab === tab.value}" @click="changeTab(tab)">{{tab.label}}</p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex aic">
      <!-- hover弹框内容 -->
      <div v-for="(item, ind) in headerList" :key="ind" class="flex aic">
        <poptip trigger="hover" @on-popper-show="$emit('changePopper',item)" :placement="item.type === 'login' ? 'bottom-end' : 'bottom'" class="poptip-box" :class="item.type">
          <div class="icon-box ovh tac flex aic lh1" @mouseover.stop="changeInpurFocus(item)">
            <template v-if="item.type === 'login'">
              <div class="icon-box-btn csp" v-if="!userInfo.uid" @click="ToLogin()">{{item.title}}</div>
              <img :src="userInfo.icon" v-df-avatar alt="" class="userinfo-icon" v-else>
            </template>
            <template v-else-if="item.type ==='grade'">
              <div class="flex aic csp grade-name fs14 color_999" v-if="currGrade">
                <p class="pr5">{{currGrade.short_name || currGrade.name}}</p>
                <p class="header-icon bottom_arrow_icon"></p>
              </div>
            </template>
            <template v-else>
              <div class="por icon-box-content csp">
                <div class="header-mask-icon icon-box-item por" :class="item.className">
                </div>
                <p class="icon-box-text poa fs12" :class="'icon_'+ind">{{item.desc}}</p>
              </div>
            </template>
          </div>
          <div slot="content" class="content-box">
            <!-- 年级 -->
            <template v-if="item.type === 'grade'">
              <div class="grade-box">
                <template v-for="(item,i) in gradeList">
                  <div :key="i" class="flex" v-if="item.list.length">
                    <p class="grade-box-title fs16 color_333">{{item.title}}</p>
                    <div class="flex-1 flex aic jcb fww grade-box-item">
                      <p v-for="(val,ind) in item.list" :key="ind" class="fs14 grade-box-name tac csp" :class="{active: +currGrade.id === +val.id}" @click="changeGrade(val)">
                        {{val.short_name || val.name}}
                      </p>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else-if="item.type ==='search'">
              <!-- 搜索框 -->
              <div class="search-input flex aic jcc">
                <div class="search-content por">
                  <i-input :placeholder="`搜索课程 / 老师`" class="input por" v-model="keyWord" search @on-search="changeJumpEvent('search')" @on-focus="changeFocus" @on-blur="changeBlur" ref="input"
                    autofocus>
                    <div slot="append" class="search-text csp" @click="changeJumpEvent('search')"><i class="header-icon search_icon"></i>搜索</div>
                  </i-input>
                  <div class="poa t0 l0 search-history" v-show="isFocus && historyList.length">
                    <p class="search-history-title flex aic jcb"><span class="">历史记录：</span><span class="header-icon del_icon csp" @click.native="delHistory" @mousedown="delHistory"></span></p>
                    <div class="flex aic fww">
                      <p v-for="(val,i) in historyList" :key="i" class="search-history-item csp" @mousedown="changeSearch(val)" @click.native="changeSearch(val)">{{val}}</p>
                    </div>
                  </div>
                  <div class="search-hot flex fww aic">
                    <i class="header-icon search_hot_icon"></i>
                    <p class=""><span class="">热门搜索：</span></p>
                    <p v-for="(hot,i) in hotSearch" :key="i" class="search-hot-item csp" @click="changeSearch(hot.name)"><span v-show="i <= 2" class="search-hot-count">{{i+1}}</span>{{hot.name}}</p>
                  </div>
                </div>
              </div>
            </template>
            <!-- vip会员 -->
            <template v-else-if="item.type === 'vip'">
              <div class="vip-box ">
                <div v-for="(vip,i) in vipList" :key="i" class="vip-box-item flex aic jcc csp" @click="changeJumpEvent(vip.prop)">
                  <icon class="header-icon" :class="vip.className"></icon>
                  <p class="fs16 vip-box-label">{{vip.label}}</p>
                </div>
              </div>
            </template>
            <!-- 播放记录 -->
            <template v-else-if="item.type === 'record'">
              <!-- 未登录 -->
              <template v-if="!userInfo.uid">
                <div class="record-box">
                  <div class="record-box-nologin tac">
                    <p class="record-box-nologin-text fs16 color_999">登录即可查看播放记录</p>
                    <p class="record-box-nologin-btn fs16 mlr-auto csp" @click="changeJumpEvent('login')">立即登录</p>
                  </div>
                </div>
              </template>
              <!-- 已登录 -->
              <template v-else>
                <div class="record-content por ovh">
                  <div class="record-content-list ova" v-if="listLength">
                    <div v-for="(record,i) in recordList" :key="i" class="pb5">
                      <template v-if="record.list.length">
                        <p class="color_666 fs14 record-content-title">{{record.name}}</p>
                        <course-card v-for="(course,j) in record.list" :key="j" :item="course" image-width="120" image-height="68" imgKey="course_bigimg" flex="flex" class="record-course"
                          @detail="changeJumpEvent('record_course',$event)" :change-prop="{'course_name': 'name'}" showProps="name,slot_name" hidden-audio>
                          <template #slot_name="{item}">
                            <p name="slot_resources_name" class="color_999 fs14 wot1 slot_name">已学至：{{item.resources_name}}</p>
                          </template>
                        </course-card>
                      </template>
                    </div>
                  </div>
                  <div class="w100 h100 flex-col aic jcc" v-else>
                    <i class="course-icon no_data"></i>
                    <p class="color_999">暂无内容，快去看看精彩视频吧~</p>
                  </div>
                  <div class="record-content-footer poa b0 color_999">
                    <p class="fs16 tac csp record-content-more" @click="changeJumpEvent('more')">查看更多</p>
                  </div>
                </div>
              </template>

            </template>
            <!-- 登录/注册 -->
            <template v-else-if="item.type === 'login'">
              <div class="login-box">
                <!-- 未登录 -->
                <template v-if="!userInfo.uid">
                  <div class="nologin-box">
                    <p class="nologin-box-title fs18 color_333">{{noLoginInfo.title}}</p>
                    <div class=" flex aic fww nologin-box-content">
                      <div v-for="(val,idx) in noLoginInfo.list" :key="idx" class="w50 flex aic nologin-box-list">
                        <icon class="header-icon" :class="val.className"></icon>
                        <div class="pl10">
                          <p class="fs16 color_333">{{val.label}}</p>
                          <p class="fs14 color_999">{{val.desc}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="nologin-box-btn flex aic">
                      <p class="fs16 color_333">1秒登录，开始学习：</p>
                      <div v-for="(btn,index) in btnList" :key="index" :class="btn.bg" class="por csp" @click="changeJumpEvent(btn.type)">
                        <icon class="header-icon" :class="btn.className"></icon>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 已登录 -->
                <template v-else>
                  <div class="loginInfo-box">
                    <div class="flex aic user-box por">
                      <div class="user-img ovh zi1">
                        <img :src="userInfo.icon" alt="" class="w100 h100" v-df-avatar>
                      </div>
                      <div class="header-icon user_vip_icon poa" v-if="payVipList.length"></div>
                      <div class="flex-1">
                        <div class="flex aic jcb">
                          <span class="dib color_333 fs16">{{userInfo.realname || userInfo.nickname || '用户' + userInfo.username}}</span>
                          <!-- <p class="fs16"><span class="color_999">账号ID：</span><span class="dib user-text color_333">{{userInfo.username}}</span></p> -->
                          <span class="dib flex aic fs14 color_999 csp user-personal" @click="changeJumpEvent('personal')">进入个人中心<icon class="header-icon right_arrow pl2"></icon></span>
                        </div>
                        <p class="fs16"><span class="color_999">账号ID：</span><span class="dib user-text color_333">{{userInfo.username}}</span></p>
                        <p class="fs16"><span class="color_999">手机号：</span><span class="dib color_333">{{userInfo.phone}}</span></p>
                      </div>
                    </div>
                    <!-- 会员显示 -->
                    <div>
                      <template v-if="!payVipList.length">
                        <div class="flex aic jcb">
                          <div v-for="(info,i) in vipBtnList" :key="i" class="flex aic jcc csp" :class="info.bg" @click="changeJumpEvent(info.type)">
                            <icon class="header-icon" :class="info.className"></icon>
                            <p class="fs20 vip-label">{{info.label}}</p>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="w100 flex aic">
                          <div class="w100 vip-content flex-col jca" :class="{'vip-more':payVipList.length > 1}">
                            <div class="flex aic jcb pb10">
                              <p class="flex aic fs18">
                                <icon class="header-icon vip_icon_1 vip-content-icon"></icon>
                                <span class="vip-content-title">{{payVipList[0].name}}</span>
                              </p>
                              <p class="flex aic jcb fs14 csp vip-content-pay" @click="changeJumpEvent('open')">
                                <span class="">续费</span>
                                <icon class="header-icon right_arrow_2 pb2"></icon>
                              </p>
                            </div>
                            <p class="fs14">会员到期时间：{{Tools.formatDate(payVipList[0].end_time,
                'Y年M月D日')}}</p>
                          </div>
                          <p class="flex-1 look-more csp fs12" @click="changeJumpEvent('more_vip')" v-if="payVipList.length > 1">查看更多</p>
                        </div>
                      </template>
                    </div>
                    <!-- 功能列表 -->
                    <div class="func-content color_666 flex aic jcb">
                      <div class="func-content-item flex-col aic jcc csp" v-for="(func,i) in loginList" :key="i" @click="changeJumpEvent(func.type)">
                        <icon class="header-icon" :class="func.className"></icon>
                        <p class="func-content-label">{{func.label}}</p>
                      </div>
                    </div>
                    <!-- 退出登录 -->
                    <p class="fr out-login color_999 fs14 csp" @click="changeJumpEvent('outlogin')">退出登录</p>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </poptip>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "HeaderDf",
  props: {
    // 值为true的时候不显示选中效果
    noTabsActive: {
      type: Boolean,
      default: false,
    },
		isTbVideo:{
			type:Boolean,
			default:false
		}
  },
  data () {
    return {
      headerList: [
        { title: '年级', id: 1, type: 'grade', },
        { title: '搜索框', id: 2, type: 'search', className: 'search_icons', desc: '搜索' },
        { title: '播放记录', id: 3, type: 'record', className: 'record_icon', desc: '记录' },
        { title: 'VIP会员', id: 4, type: 'vip', className: 'vip_icon', desc: '会员' },
        { title: '登录', id: 5, type: 'login' },
      ],
      gradeList: {
        1: { id: 1, title: '学前', list: [] },
        2: { id: 2, title: '小学', list: [] },
        3: { id: 3, title: '初中', list: [] },
        4: { id: 4, title: '高中', list: [] },
        5: { id: 5, title: '专项', list: [] }
      },
      vipList: [
        { icon: '', label: '开通会员', prop: 'open', className: 'vip_icon_1' },
        { icon: '', label: '了解会员权益', prop: 'understand', className: 'vip_icon_2' },
      ],
      noLoginInfo: {
        title: '登录格灵云课堂，享更多学习特权',
        list: [
          { label: '同步知识学习', desc: '预复习快人一步', className: 'login_icon_1' },
          { label: '教材同步学', desc: '多版本教材学习', className: 'login_icon_2' },
          { label: '精彩课程及时看', desc: '拓展知识库', className: 'login_icon_3' },
          { label: '好礼限时领', desc: '惊喜活动等你来', className: 'login_icon_4' },
        ]
      },
      loginList: [
        { type: 'play', label: '观看记录', className: 'login_icon_5' },
        { type: 'collection', label: '我的收藏', className: 'login_icon_6' },
        { type: 'course', label: '已购课程', className: 'login_icon_7' },
        { type: 'app', label: '下载APP', className: 'login_icon_8' },
        { type: 'help', label: '帮助中心', className: 'login_icon_9' },
      ],
      vipBtnList: [
        { type: 'open', label: '开通会员', className: 'vip_icon_1', bg: 'vip-open' },
        { type: 'exchange', label: '兑换会员', className: 'exchange_icon', bg: 'vip-exchange' },
      ],
      btnList: [
        { type: 'phone', className: 'phone_icon', bg: 'btn-phone' },
        { type: 'wx', className: 'wx_icon', bg: 'btn-wx' },
      ],
      tabs_1: [
        { label: '首页', value: 'home' },
        { label: '同步课程', value: 'tb' },
        { label: '精品专区', value: 'boutique' },
        { label: '专题课堂', value: 'special' },
        { label: '有声频道', value: 'sound' },
        { label: '家长专区', value: 'parent' },
      ],
      tabs_2: [
        { label: '首页', value: 'home' },
        { label: '启蒙早教', value: 'initiate' },
        { label: '少儿', value: 'less' },
        { label: '百科知识', value: 'knowledge' },
        { label: '精品专区', value: 'boutique' },
        { label: '有声频道', value: 'sound' },
        { label: '家长育儿', value: 'parent' },
      ],
      specialList: {
        102: [ // 微课
          { label: '首页', value: 'home' },
          { label: '同步微课', value: 'weike' },
          { label: '才艺', value: 'caiyi' },
          { label: '科学百科', value: 'kexue' },
          { label: '专题频道', value: 'zhuanti' },
          { label: '有声频道', value: 'sound' },
          { label: '家长专区', value: 'parent' },
          { label: '精品专区', value: 'boutique' },
        ],
        111: [ // 国学
          { label: '首页', value: 'home' },
          { label: '国学经典', value: 'gouxue' },
          { label: '兴趣培养', value: 'xingqu' },
          { label: '益智科普', value: 'kepu' },
          { label: '有声频道', value: 'sound' },
          { label: '家长专区', value: 'parent' },
          { label: '精品专区', value: 'boutique' },
        ],
        112: [ // 故事
          { label: '首页', value: 'home' },
          { label: '故事', value: 'gushi' },
          { label: '才艺', value: 'caiyi' },
          { label: '科学', value: 'kexue' },
          { label: '专题', value: 'zhuanti' },
          { label: '有声频道', value: 'sound' },
          { label: '家长专区', value: 'parent' },
          { label: '精品专区', value: 'boutique' },
        ],
        114: [ // 奥数
          { label: '首页', value: 'home' },
          { label: '奥数', value: 'aoshu' },
          { label: '才艺', value: 'caiyi' },
          { label: '科学', value: 'kexue' },
          { label: '专题', value: 'zhuanti' },
          { label: '有声频道', value: 'sound' },
          { label: '家长专区', value: 'parent' },
          { label: '精品专区', value: 'boutique' },
        ],
      },
      keyWord: '', // 搜索关键词
      today: [],
      week: [],
      more: [],
      currStr: '',
      timeStr: 'Y-M-D',
      weekStr: [],
      payVipList: [], // 购买的会员列表
      hotSearch: [], // 热门搜索列表
      historyList: [], // 搜索记录
      isFocus: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGrades', 'currGrade', 'currTab', 'searchHistory','refreshHistory','newApiToken','oldToken','currAudio','currUserVip']),
    currentTab () {
      let curr = this.$route.path.split('/')[2];
			let currTab = this.tabsList.find(e=>e.value===this.$route.path.split('/')[3])
			if(curr === 'search'){
				return ''
			}
			if(curr === 'audio'){
				return 'sound'
			}
			if(this.isTbVideo){
				return 'tb'
			}
      return {
        home: 'home',
        boutique: 'boutique',
        parent: 'parent',
        sound: 'sound',
        special: 'special',
        tb: 'tb',
      }[curr] || this.$route.query.currTab || (currTab ? currTab.value : '');
    },
    tabsList () {
      let list = '';
      if(this.currGrade){
        switch(+this.currGrade.pid){
          case 1:
            list = this.tabs_2;
            break;
          case 5:
            list = this.specialList[this.currGrade.id];
            break;
          default:
            list = this.tabs_1;
            break;
        }
      }
      let noShow = ['Download'].includes(this.$route.name);
      !list.find(e => e.value === this.currTab) && !noShow && this.changeTab({ value: 'home' });
			this.setAllTabsList(list)
      return list;
    },
    listLength () {
      return this.today.length + this.week.length + this.more.length;
    },
    recordList () {
      return [
        { name: '今天', list: this.today },
        { name: '一周内', list: this.week },
        { name: '更早', list: this.more },
      ]
    },
  },
  watch: {
		refreshHistory(val){
			//刷新状态改变则请求获取浏览记录接口
			if(val){
				this.getRerocdList();
			}
		}
	},
  created () {
    this.currStr = this.Tools.formatDate(new Date(), this.timeStr);
    for (let i = 6; i > 0; i--) {
      this.weekStr.push(this.Tools.typeToDate(i).map(e => this.Tools.formatDate(e, this.timeStr))[0]);
    }
    if (this.userInfo.uid) {
      this.getRerocdList();
      this.getVipList();
      this.getUserVipList();
			// console.log("this.userInfo",this.userInfo)
    }
    this.getGradeList();
    this.getHotSearch();
  },
  methods: {
    ...mapMutations(['setCurrGrade', 'setAllGrades', 'setNewApiToken', 'setUserInfo', 'setCurrTab', 'setCurrAudio', 'setSearchHistory', 'setCurrUserVip', 'setOldToken','setAllTabsList']),
    // 搜索框自动聚焦
    changeInpurFocus (item) {
      if (item.type === 'search') {
        let input = this.$refs.input[0];
        input.focus();
      }
    },
    changeTab (tab) {
      if (this.$listeners['change-tab']) {
        return this.$emit('change-tab', tab);
      }
      let url = `/home/page/${tab.value}`;
      this.setCurrTab(tab.value);
      let isOpen = ['HomeVideoDetails'].includes(this.$route.name);
      isOpen ? this.OpenRouter(url,true) : this.$router.push(url);
    },
    // 获取热门搜索
    getHotSearch () {
      this.http.NEWKeywordSearch({ ...this.Product }).then(res => {
        this.hotSearch = res.list.slice(0, 10);
      }).catch(console.log);
    },
    // 获取固定会员列表
    getVipList () {
      this.http.NEWVipList({ uid: this.userInfo.uid }).then(res => {
        this.payVipList = res.list;
      }).catch(console.log);
    },
    getUserVipList () {
      this.http.NEWUserVipList({ uid: this.userInfo.uid, curr: 1, limits: 20 }).then(res => {
        if (res.list.length) {
          let list = [];
          res.list.forEach(e => {
            switch (e.product_id) {
              case 2:
                list.push({ id: 102, name: '微课', short_name: '微课', pid: 5 });
                break;
              case 11:
                list.push({ id: 111, name: '国学', short_name: '国学', pid: 5 });
                break;
              case 12:
                list.push({ id: 112, name: '故事', short_name: '故事', pid: 5 });
                break;
              case 14:
                list.push({ id: 114, name: '奥数', short_name: '奥数', pid: 5 });
                break;
            }
          })
          if (list.length) {
            this.gradeList['5'].list = list;
            !window.sessionStorage.getItem('newPage') && !this.userInfo.select_nianji_id && this.setCurrGrade(list[0]);
          }
        }
      }).catch(console.log);
    },
    // 获取播放记录列表
    getRerocdList () {
      let params = {
        uid: this.userInfo.uid,
        curr: 1,
        limits: 10,
        ...this.Product
      }
      this.http.NEWCourseRecordList(params).then(res => {
				//重置数据
				this.today = [];
				this.week = [];
				this.more = [];
				// 对结果进行时间轴对比
        res.list.forEach(e => {
          let curr = this.Tools.formatDate(e.time, this.timeStr);
          if (curr === this.currStr) {
            this.today.push(e);
          } else if (this.weekStr.includes(curr)) {
            this.week.push(e);
          } else {
            this.more.push(e);
          }
        });
      }).catch(this.$err);
    },
    // 获取年级列表
    async getGradeList () {
      let res = await this.GetGradeList();
      res.forEach(e => {
        if (+e.pid !== 4) {
          this.gradeList[e.pid].list.push(e);
        } else if (+e.pid === 4 && (e.id === 18 || e.id === 19 || e.id === 20)) {
          this.gradeList[e.pid].list.push(e);
        }
      })
    },
    // 选择年级
    changeGrade (val) {
      this.setCurrGrade(val);
			if(this.userInfo&&this.userInfo.uid){
				this.http.NEWSetSelectGrade({
					uid: this.userInfo.uid,
					nianji_id: val.id,
					...this.Product,}).catch(this.$err).finally(() => {
					this.GetUserInfoApi(this.userInfo.uid);
				});
			}
			
    },
    // 聚焦
    changeFocus () {
      this.isFocus = true;
      this.historyList = this.searchHistory[this.userInfo.uid] || [];
    },
    // 失去焦点
    changeBlur () {
      setTimeout(() => {
        this.isFocus = false;
      }, 100)
    },
    // 搜索历史记录
    changeHistory () {
      if (!this.userInfo.uid) { return };
      let history = {}, list = this.historyList;
      let index = list.indexOf(this.keyWord);
      index !== -1 && list.splice(index, 1);
      list.unshift(this.keyWord);
      this.historyList = list.slice(0, 10);
      history[this.userInfo.uid] = this.historyList;
      this.setSearchHistory(history);
    },
    delHistory () {
      this.historyList = [];
      this.searchHistory[this.userInfo.uid] = [];
      this.setSearchHistory(this.searchHistory);
    },
    // 搜索跳转
    changeSearch (name) {
      this.keyWord = name;
      this.changeJumpEvent('search');
    },
    // 跳转事件
    async changeJumpEvent (type, item) {
      let url = '';
      switch (type) {
        case 'phone':
        case 'wx':
          this.ToLogin({ value: type });
          break;
        case 'outlogin':
					localStorage.clear();
					sessionStorage.clear();
          await this.setUserInfo({});
          await this.setNewApiToken('');
          await this.setOldToken('');
          await this.setCurrAudio('');
          await this.setCurrUserVip({});
          if(this.currGrade && +this.currGrade.pid === 5){
            await this.setCurrGrade({ id: 8, name: "小学一年级", short_name: "一年级", pid: "2" });
          }
					if(JSON.stringify(this.userInfo) === '{}' && !this.newApiToken && !this.oldToken && !this.currAudio && JSON.stringify(this.currUserVip) === '{}'){
						location.reload();
					}
          break;
        case 'login':
          this.ToLogin();
          break;
        case 'search':
          // 跳转搜索页
          if(!this.keyWord) { return; }
          let reg = /^[ ]+$/;
          if(reg.test(this.keyWord)) { return; }
          this.changeHistory();
          url = `/home/search?keyword=${encodeURIComponent(this.keyWord)}`;
          this.$nextTick(() => {
            document.querySelector('.search > .ivu-poptip-popper').style.display = 'none';
          })
          break;
        case 'record_course':
          url = `/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.course_id}/${item.is_free}?rid=${item.resource_id}`;
          break;
        case 'more':
        case 'personal':
          url = '/user/play';
          break;
        case 'play':
        case 'collection':
        case 'course':
          url = `/user/${type}`;
          break;
        case 'open':
          this.ShowVip();
          break;
        case 'exchange':
          url = '/user/vip/exchange';
          break;
        case 'understand':
          url = '/user/remark';
          break;
        case 'app':
          url = '/download';
          break;
        case 'more_vip':
          url = '/user/vip/my';
          break;
        case 'help':
          url = '/help/core';
          break;
      }
      url && this.OpenRouter(url);
    },
  },
}
</script>

<style  lang="less" scoped>
@import '../../assets/less/function';

@act-color: #1177ff;

/deep/ .ivu-poptip-inner {
  white-space: unset;
  border-radius: 0px 0px 8px 8px;
  box-shadow: none;
}

/deep/ .ivu-poptip-body {
  padding: 0;
}

/deep/ .ivu-poptip-popper {
  top: 70px !important;
  .ivu-poptip-arrow {
    display: none;
  }
}

/deep/ .ivu-poptip-popper[x-placement^='bottom'] {
  padding: 0;
}

/deep/ .ivu-input {
  border: 1px solid @act-color;
  height: 50px;
  padding-left: 16px;
  font-size: 16px;
  &::-webkit-input-placeholder {
    font-size: 16px;
  }
}
.search-input {
  &:hover {
    /deep/ .ivu-input {
      &:focus {
        box-shadow: none;
      }
      // &::-webkit-input-placeholder {
      //   color: @act-color;
      // }
    }
  }
}
.search-content {
  padding: 44px 0;
  width: 800px;
  /deep/ .ivu-input-group-append {
    // padding: 0;
    border: none;
    background: @act-color;
  }
}
.search-text {
  width: 105px;
  color: #ffffff;
  font-size: 18px;
}
.search-hot {
  padding-top: 17px;
  color: #999fa6;
  &-item {
    margin-right: 16px;
    &:hover {
      color: @act-color;
    }
  }
  &-count {
    font-family: Roboto;
    margin-right: 7px;
    background: linear-gradient(162deg, #ff5776 0%, #ff1f48 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.search-history {
  width: 681px;
  background-color: #fff;
  top: 94px;
  padding: 16px 16px 10px;
  box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
  border-radius: 0px 0px 8px 8px;
  &-title {
    color: #999fa6;
    padding-bottom: 16px;
  }
  &-item {
    color: #666f7a;
    padding: 0 16px 14px 0;
    &:hover {
      color: @act-color;
    }
  }
}
.course-icon {
  .spirit(url(../../assets/images/search_icon.png));
  &.no_data {
    margin-bottom: 31px;
    &:after {
      width: 99px;
      height: 81px;
      background-position: -5px -63px;
    }
  }
}
.header-icon {
  .spirit(url(../../assets/images/home_icon.png));
  &.del_icon {
    &:after {
      width: 20px;
      height: 20px;
      background-position: -327px -94px;
    }
  }
  &.search_hot_icon {
    margin: 0 9px 5px 0;
    &:after {
      width: 11px;
      height: 15px;
      background-position: -324px -42px;
    }
  }
  &.search_icon {
    margin-right: 9px;
    &:after {
      width: 26px;
      height: 26px;
      background-position: -295px -90px;
    }
  }
  &.vip_icon_1 {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -230px -9px;
    }
  }
  &.vip_icon_2 {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -263px -9px;
    }
  }
  &.login_icon_1 {
    &:after {
      width: 44px;
      height: 44px;
      background-position: -6px -41px;
    }
  }
  &.login_icon_2 {
    &:after {
      width: 44px;
      height: 44px;
      background-position: -54px -41px;
    }
  }
  &.login_icon_3 {
    &:after {
      width: 44px;
      height: 44px;
      background-position: -102px -41px;
    }
  }
  &.login_icon_4 {
    &:after {
      width: 44px;
      height: 44px;
      background-position: -150px -41px;
    }
  }
  &.login_icon_5 {
    &:after {
      width: 28px;
      height: 28px;
      background-position: -6px -90px;
    }
  }
  &.login_icon_6 {
    &:after {
      width: 28px;
      height: 28px;
      background-position: -40px -90px;
    }
  }
  &.login_icon_7 {
    &:after {
      width: 28px;
      height: 28px;
      background-position: -74px -90px;
    }
  }
  &.login_icon_8 {
    &:after {
      width: 28px;
      height: 28px;
      background-position: -108px -90px;
    }
  }
  &.login_icon_9 {
    &:after {
      width: 28px;
      height: 28px;
      background-position: -141px -90px;
    }
  }
  &.phone_icon {
    &:after {
      width: 17px;
      height: 24px;
      background-position: -208px -51px;
    }
  }
  &.wx_icon {
    &:after {
      width: 26px;
      height: 22px;
      background-position: -237px -51px;
    }
  }
  &.right_arrow {
    &:after {
      width: 9px;
      height: 14px;
      background-position: -331px -14px;
    }
  }
  &.right_arrow_hover {
    &:after {
      background-position: -235px -97px;
    }
  }
  &.right_arrow_2 {
    &:after {
      width: 9px;
      height: 13px;
      background-position: -214px -98px;
    }
  }
  &.right_arrow_hover_2 {
    &:after {
      background-position: -259px -98px;
    }
  }
  &.exchange_icon {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -293px -9px;
    }
  }
  &.user_vip_icon {
    top: 5px;
    left: 0;
    &:after {
      width: 20px;
      height: 19px;
      background-position: -184px -96px;
    }
  }
  &.bottom_arrow_icon {
    &:after {
      width: 10px;
      height: 7px;
      background-position: -11px -16px;
    }
  }
  &.bottom_arrow_icon_hover {
    &:after {
      width: 10px;
      height: 6px;
      background-position: -278px -102px;
    }
  }
}
.header-mask-icon {
  .spirit-mask(url(../../assets/images/home_icon.png));
  &.search_icons {
    transition: transform 0.3s;
    &:after {
      width: 26px;
      height: 26px;
      mask-position: -293px -129px;
      background-color: #d2d2d2;
    }
  }
  &.record_icon {
    transition: transform 0.3s;
    &:after {
      width: 26px;
      height: 26px;
      mask-position: -86px -3px;
      background-color: #d2d2d2;
    }
  }
  &.vip_icon {
    transition: transform 0.3s;
    &:after {
      width: 26px;
      height: 26px;
      mask-position: -154px -3px;
      background-color: #edbd71;
    }
    .icon-box-text {
      color: #edbd71;
    }
  }
}
.icon-box {
  &-btn {
    width: 64px;
    height: 26px;
    line-height: 26px;
    background: #1177ff;
    border-radius: 13px;
    color: #ffffff;
    &:hover {
      background: #0066ed;
    }
  }
  .userinfo-icon {
    width: 40px;
    height: 40px;
    border: 1px solid #eee;
    border-radius: 50%;
  }
  &-content {
    width: 30px;
  }
  &-text {
    font-size: 14px;
    // left: 4px;
    bottom: -20px;
    transition: bottom 0.3s, left 0.3s;
  }
}

.header-df {
  .left {
    .logo {
      width: 170px;
      height: 70px;
    }
  }
  .grade,
  .search,
  .record,
  .login {
    /deep/ .ivu-poptip-body {
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: #eee;
      border-radius: 0 0 8px 8px;
    }
  }
  .search {
    /deep/ .ivu-poptip-popper {
      width: 100%;
      left: 0 !important;
      .ivu-poptip-inner {
        white-space: unset;
        border-radius: 0;
        // box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
      }
    }
    /deep/ .ivu-poptip-body-content {
      overflow: unset;
    }
  }
  .poptip-box {
    padding-left: 16px;
    &:hover {
      .search_icons,
      .record_icon,
      .vip_icon {
        transform: translateY(-26px);
      }
      .icon-box-text {
        bottom: 4px;
        color: @act-color;
      }
      .icon_3 {
        color: #9b632c;
      }
    }
  }
  .tabs-box {
    padding-left: 26px;
  }
  .tabs {
    padding: 22px 0;
    &-item {
      color: #737373;
      font-weight: 400;
      margin-right: 24px;
      position: relative;
      &::before {
        content: '';
        width: 0;
      }
      &:hover {
        &:not(.tabs-active) {
          &::before {
            content: '';
            width: 24px;
            height: 3px;
            background: @act-color;
            border-radius: 2px;
            position: absolute;
            bottom: -5px;
            left: 50%;
            transform: translateX(-50%);
            transition: width 0.3s ease-in-out 0s;
          }
        }
      }
    }

    &-active {
      color: @act-color;
      font-size: 18px;
      font-weight: bold;
      position: relative;
      &::before {
        content: '';
        width: 24px;
        height: 3px;
        background: @act-color;
        border-radius: 2px;
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .item-icon {
    width: 32px;
    height: 32px;
  }
  .grade-name {
    &:hover {
      color: @act-color;
      .bottom_arrow_icon {
        .header-icon .bottom_arrow_icon_hover;
      }
    }
  }
  .grade-box {
    width: 376px;
    // height: 293px;
    padding: 22px 32px 0;
    &-title {
      width: 50px;
      height: 28px;
      line-height: 28px;
      padding-right: 16px;
    }
    &-name {
      width: 80px;
      height: 28px;
      line-height: 28px;
      background: #f2f2f2;
      border-radius: 14px;
      margin-bottom: 16px;
      .color_666;
      &:not(.active) {
        &:hover {
          background: #e1eeff;
          color: @act-color;
        }
      }
    }
  }
  .active {
    background: @act-color;
    color: #ffffff;
  }
  .vip-box {
    line-height: 1;
    width: 200px;
    background: url(../../assets/images/header/home_vipjs.png) no-repeat top
      left / 100%;
    border-radius: 0 0 8px 8px;
    &-item {
      height: 55px;
      &:first-child {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 152px;
          height: 1px;
          background: #64360d;
          opacity: 0.2;
        }
      }
    }
    &-label {
      padding-left: 12px;
      color: #9b632c;
    }
  }
  .record-box {
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    &-nologin {
      width: 208px;
      height: 128px;
      &-text {
        padding: 23px 0;
      }
      &-btn {
        width: 112px;
        height: 32px;
        background: @act-color;
        border-radius: 16px;
        color: #ffffff;
        line-height: 32px;
        &:hover {
          background: #0066ed;
        }
      }
    }
  }
  .record-content {
    width: 456px;
    height: 543px;
    line-height: 1;
    border-radius: 0 0 8px 8px;
    &-footer {
      width: 100%;
      height: 56px;
      line-height: 56px;
      background: #ffffff;
      z-index: 2;
    }
    &-more:hover {
      color: @act-color;
    }
    &-title {
      padding-bottom: 12px;
    }
    &-list {
      padding: 30px 24px 56px;
      height: 100%;
    }
  }
  .login-box {
    width: 456px;
    background: #ffffff;
    border-radius: 8px;
    .nologin-box {
      padding: 24px 24px 0;
      &-title {
        padding-bottom: 24px;
      }
      &-content {
        border-bottom: 1px solid #dddddd;
        margin-bottom: 18px;
      }
      &-list {
        padding-bottom: 31px;
      }
      &-btn {
        padding-bottom: 18px;
      }
      .btn-phone {
        width: 40px;
        height: 40px;
        background: #f5991f;
        border-radius: 50%;
        margin: 0 24px;
        .phone_icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &:hover {
          background: #ed8e10;
        }
      }
      .btn-wx {
        width: 40px;
        height: 40px;
        background: #00c250;
        border-radius: 50%;
        .wx_icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &:hover {
          background: #09b43f;
        }
      }
    }
    .loginInfo-box {
      padding: 24px 24px 0;
      .user-box {
        padding-bottom: 22px;
      }
      .user-personal:hover {
        color: @act-color;
        .right_arrow {
          .header-icon .right_arrow_hover;
        }
      }
      .user-img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 16px;
        border: 1px solid #eee;
      }
      .user-text {
        padding: 12px 0 11px 0;
      }
      .vip-open {
        width: 196px;
        height: 56px;
        background: url(../../assets/images/header/home_ktvip.png) no-repeat top
          left / 100%;
      }
      .vip-exchange {
        width: 196px;
        height: 56px;
        background: url(../../assets/images/header/home_dhvip.png) no-repeat top
          left / 100%;
      }
      .vip-label {
        color: #9b632c;
        padding-left: 12px;
      }
      .vip-content {
        line-height: 1;
        height: 68px;
        background: url(../../assets/images/header/home_vipcard.png) no-repeat
          top left / 100%;
        padding: 13px 20px 11px 30px;
        color: #9b632c;
        &-title {
          padding-left: 13px;
        }
        &-icon {
          padding-bottom: 2px;
        }
        &-pay {
          width: 54px;
          height: 23px;
          padding: 0 5px;
          &:hover {
            background: #835120;
            border-radius: 12px;
            color: #ffffff;
            .right_arrow_2 {
              .header-icon .right_arrow_hover_2;
            }
          }
        }
      }
      .vip-more {
        width: 360px;
        background: url(../../assets/images/header/home_morevip.png) no-repeat
          top left / 100%;
      }
      .look-more {
        padding-left: 16px;
        color: #9b632c;
      }
      .func-content {
        padding: 25px 14px;
        font-size: 13px;
        &-item:hover {
          color: @act-color;
        }
        &-label {
          padding-top: 9px;
        }
      }
      .out-login {
        padding-bottom: 23px;
        &:hover {
          color: @act-color;
        }
      }
    }
  }
  .record-course {
    margin-bottom: 16px;
    /deep/ .vip-type-tip {
      display: none;
    }
    /deep/ .detail-box {
      padding: 0 0 0 10px;
      .slot_name {
        padding-top: 17px;
      }
      .name {
        padding-top: 9px;
      }
    }
  }

  .color_999 {
    color: #999fa6;
  }
  .color_666 {
    color: #666f7a;
  }
  .color_333 {
    color: #333f4e;
  }
  .wot_1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>